import { render, staticRenderFns } from "./BankEdit.vue?vue&type=template&id=fa0e1e98&scoped=true"
import script from "./BankEdit.vue?vue&type=script&lang=js"
export * from "./BankEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0e1e98",
  null
  
)

export default component.exports